import Slider from "react-slick";
function Moments() {
    var settings = {
        className: "slider variable-width",
        dots: true,
        infinite: true,
        speed: 3000,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 2500,
        cssEase: "linear"
    };
    const imgList = [1, 2, 3, 5, 6, 7, 8]
    return <div className="sliderContainer">
        <Slider {...settings}>
            {imgList.map((image, index) => (<div key={"moments-" + index} className="sliderListItem">
                <img src={`/images/moments/${image}.jpg`} alt={"moment-" + index} />
                {/* {index} */}
            </div>))}
        </Slider>
    </div>
}

export default Moments
